import jsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable';

export const generatePolicySummaryPDF = (workflowData: any) => {
  const doc = new jsPDF();

  const quoteNumber = workflowData?.storedQuoteNumber || 'Policy_Summary';

  doc.setFontSize(20);
  doc.text('Policy Summary', 105, 20, { align: 'center' });

  let yPosition = 40;

  doc.setFontSize(16);
  doc.text('Client & Policy Details', 20, yPosition);
  yPosition += 10;

  doc.setFontSize(12);
  const clientName = `${workflowData?.step1?.firstName || "Client"} ${workflowData?.step1?.lastName || ""}`.trim();
  const autoCarrier = workflowData?.step4?.carrier || "Selected Carrier";
  const autoPolicyNumber = workflowData?.step9?.policyNumber || "Pending";
  const monthlyPayment = `$${workflowData?.step8?.monthlyPayment || "0.00"}`;
  const firstPaymentDate = workflowData?.step8?.firstPaymentDate || "TBD";

  doc.text(`Client Name: ${clientName}`, 20, yPosition);
  yPosition += 10;
  doc.text(`Auto Carrier: ${autoCarrier}`, 20, yPosition);
  yPosition += 10;
  doc.text(`Auto Policy Number: ${autoPolicyNumber}`, 20, yPosition);
  yPosition += 10;
  doc.text(`Monthly Payment: ${monthlyPayment}`, 20, yPosition);
  yPosition += 10;
  doc.text(`First Payment Due Date: ${firstPaymentDate}`, 20, yPosition);
  yPosition += 20;

  const ancillaryProducts = workflowData?.step7?.selectedAncillary || [];
  if (ancillaryProducts.length > 0) {
    doc.text('Ancillary Products:', 20, yPosition);
    yPosition += 10;
    ancillaryProducts.forEach((prod: string) => {
      doc.text(`- ${prod}`, 30, yPosition);
      yPosition += 10;
    });
  }
  yPosition += 10;

  doc.setFontSize(16);
  doc.text('Estimated Commissions', 20, yPosition);
  yPosition += 10;

  const autoPremium = parseFloat(workflowData?.step8?.totalPremium || "0");
  const agencyFee = parseFloat(workflowData?.step8?.agencyFee || "30");
  const ancillaryPremium = parseFloat(workflowData?.step8?.ancillaryPremium || "50");

  const tableData = [
    ['Type', 'Carrier', 'Total Premium', 'Est. Comm'],
    ['Auto', autoCarrier, `$${autoPremium}`, `$${(autoPremium * 0.12).toFixed(2)}`],
    ['Ancillary', 'Way+', `$${ancillaryPremium}`, `$${(ancillaryPremium * 0.66).toFixed(2)}`],
    ['Agency Fee', '', `$${agencyFee}`, `$${agencyFee.toFixed(2)}`],
  ];

  autoTable(doc, {
    startY: yPosition,
    head: [tableData[0]],
    body: tableData.slice(1),
    theme: 'grid',
    styles: { fontSize: 10 },
    headStyles: { fillColor: [41, 128, 185] },
  });

  yPosition = (doc as any).lastAutoTable.finalY + 20;

  doc.setFontSize(16);
  doc.text('Next Steps', 20, yPosition);
  yPosition += 10;

  doc.setFontSize(12);
  doc.text('1. Check your email for policy documents and welcome kit.', 20, yPosition);
  yPosition += 10;
  const expirationDate = workflowData?.step4?.policyExpirationDate || "TBD";
  doc.text(`2. Renewal reminder will be sent 30 days before expiration (${expirationDate}).`, 20, yPosition);
  yPosition += 10;
  doc.text('3. Contact support if you have questions about your coverage.', 20, yPosition);

  doc.save(`${quoteNumber}.pdf`);
};